<template>
  <div class="home">
    <my-header activeNum="2" panoNum="1" userNum="1"></my-header>
    <div class="main">
      <div class="page">
        <div class="page-left">
          <div :class="{'page-left-li':true,'active':type=='1'}" @click="changeType(1)">全景图片</div>
          <div :class="{'page-left-li':true,'active':type=='2'}" @click="changeType(2)">全景视频</div>
          <!-- <div :class="{'page-left-li':true,'active':id=='3'}">模型</div> -->
          <!-- <div :class="{'page-left-li':true,'active':id=='4'}">图片</div>
          <div :class="{'page-left-li':true,'active':id=='5'}">视频</div>
          <div :class="{'page-left-li':true,'active':id=='6'}">音频</div>-->
          <div class="line"></div>
          <!-- <div class>
            <div class>
              <span>空间容量</span>
              <div class="">
                <svg width="16" height="16">
                  <g fill="#000" fill-rule="nonzero">
                    <path
                      d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 12.813A5.813 5.813 0 018 2.187a5.813 5.813 0 010 11.626z"
                    />
                    <path
                      d="M9.744 4.948A2.634 2.634 0 008 4.312c-.656 0-1.275.227-1.744.636-.487.427-.756 1-.756 1.614v.12c0 .068.056.124.125.124h.75a.125.125 0 00.125-.125v-.119c0-.689.673-1.25 1.5-1.25s1.5.561 1.5 1.25c0 .486-.344.932-.877 1.136a1.746 1.746 0 00-1.125 1.654v.335c0 .07.057.126.125.126h.75a.125.125 0 00.125-.126v-.354c0-.308.194-.59.483-.7.922-.355 1.517-1.167 1.517-2.07.002-.615-.267-1.188-.754-1.615zM7.375 11.438a.625.625 0 101.25 0 .625.625 0 00-1.25 0z"
                    />
                  </g>
                </svg>
              </div>
            </div>
            <div>0.00B / 3GB</div>
          </div>
          <div class="line"></div>-->
          <!-- <div class="word">
            <p>支持 2:1 图片上传</p>
            <p>2:1 最大支持 120MB 以内的全景图片</p>
          </div>-->
        </div>
        <div class="page-right">
          <div class="right-block">
            <div class="search-line">
              <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
            </div>
            <div class="list-header"></div>
            <div class="list">
              <div class="list-li" v-for="(item,i) in arr" :key="i">
                <div class="img-block">
                  <!-- <img :src="item.thumbnailUrl" /> -->
                </div>
                <div class="middle">
                  <div class="li-title">
                    [
                    <span>风光</span>]
                    <span class="li-title-span">{{item.sceneName}}</span>
                  </div>
                  <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
                </div>
                <div class="btns">
                  <router-link :to="'../panoedit/basic?id='+item.id" class="edit">编辑</router-link>
                  <div class="del" @click="del(item.id)">删除</div>
                </div>
              </div>
            </div>
            <div class="page-block">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                layout="total, prev, pager, next, jumper"
                :total="page.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<style scoped>
.home {
  height: auto;
  min-width: 1180px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  margin: 20px auto;
  width: 1180px;
  min-height: calc(100vh - 130px);
}

.page {
  display: flex;
  justify-content: space-between;
  min-height: calc(100vh - 130px);
}

.page-left {
  position: relative;
  width: 210px;
}

.page-left-li {
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  color: rgb(95, 95, 95);
  cursor: pointer;
  background-color: transparent;
  border-radius: 5px;
}

.page-left-li.active {
  color: rgb(255, 255, 255);
  background-color: rgb(40, 110, 250);
}
.line {
  height: 1px;
  background-color: rgb(222, 222, 222);
  margin-top: 20px;
  margin-bottom: 20px;
}
.word {
  font-size: 12px;
  color: rgb(122, 122, 122);
  line-height: 17px;
}

.page-right {
  position: relative;
  width: 950px;
  min-height: calc(100vh - 130px);
  background-color: white;
}

.right-block {
  display: flex;
  /* position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; */
  padding: 20px 20px 10px;
  flex-flow: column nowrap;
}

.search-line {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.input-with-select {
  width: 180px;
}

.list-header {
  height: 50px;
  width: 100%;
  background-color: #f8f8f8;
}

.list {
  /* height: 720px; */
  
}

.list-li {
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 40px;
  margin-left: 10px;
  line-height: 1.4286;
  flex-flow: column nowrap;
  flex: 1 1 auto;
}

.img-block {
  width: 40px;
  height: 40px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.li-title-span {
  display: inline-block;
  max-width: 350px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  cursor: pointer;
  margin-left: 15px;
  overflow: hidden;
}

.page-block {
  display: flex;
  justify-content: center;
}

.btns {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.edit {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
  text-decoration: none;
}

.del {
  position: relative;
  margin-left: 20px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  color: #286efa;
  font-size: 12px;
  line-height: 24px;
}
</style>
<script>
import https from "../https.js";
import MyHeader from "../components/header.vue";
import MyFooter from "../components/footer.vue";
export default {
  name: "",
  components: {
    MyHeader: MyHeader,
    MyFooter: MyFooter
  },
  data() {
    return {
      type: 1,
      searchTxt: "",
      page: {
        currentPage: 1,
        total: 0
      },
      arr: []
    };
  },
  created() {},
  mounted() {
    let t = this.$route.query.type || 1;
    this.type = t;
    this.init();
  },
  methods: {
    init() {
      https
        .fetchPost("/api/Scene/Get", {
          sceneName:this.searchTxt,
          type:this.type,
          pageIndex: this.page.currentPage,
          pageSize: 10
        })
        .then(res => {
          console.log(res.data);
          this.page.total = res.data.count;
          this.arr = res.data.result;
        });
    },
    search(){
this.page.currentPage = 1;
this.init()
    },
    changeType(num){
      this.type=num;
      this.page.currentPage = 1;
      this.init();
      this.$router.push('../my/product?type='+this.type)

    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.init();
    },
    del(id) {
      this.$confirm("此操作将永久删除该场景, 是否继续?", "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "warning"
      })
        .then(() => {
          https
            .fetchPost("/api/Scene/Edit", {
              id: id,
              status: 0
            })
            .then(res => {
              console.log(res.data);
              this.$message({
                showClose: true,
                type: "success",
                message: "删除成功!"
              });
              this.init();
            });
        })
        .catch(() => {});
    }
  }
};
</script>
